/*********************************************************************************************
* Initialize the Splide carousel for the cart section.
	*
*/
function mmInitSplideRea() {
    const id = '.splide-rea';
    const splideElem = document.querySelector(id);

    if (splideElem) {
        new Splide(splideElem, {
            type: 'splide',
			      autoplay: true,
            arrows: false,
            pagination: true,
            rewind: true,
            gap: 12,
            perPage: 1
        }).mount();
    }
}

function mmInitSplideCross() {
    const id = '.splide-cross';
    const splideElem = document.querySelector(id);

    if (splideElem) {
        new Splide(splideElem, {
            type: 'splide',
            arrows: false,
            pagination: false,
            rewind: true,
            gap: 12,
            perPage: 1
        }).mount();
    }
}

/*********************************************************************************************
* Creates a debounced function that delays invoking func until after duration milliseconds have elapsed since the last time the debounced function was invoked.
	*
	* @param {Function} func - The function to debounce.
	* @param {number} duration - The number of milliseconds to delay.
	* @returns {Function} - The debounced function.
*/
function debounce(func, duration) {
    let timeout;
    return function (...args) {
        const effect = () => {
            timeout = null;
            return func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(effect, duration);
    };
}

/*********************************************************************************************
* Get the full cart section ID from the DOM.
	*
	* @returns {HTMLElement} - The full cart section ID with the prefix.
*/
function mmCartSectionIdLong() {
	return document.querySelector('.mm-cart').id;
}

/*********************************************************************************************
* Get the cart section ID from the DOM, removing the "shopify-section-" prefix.
	*
	* @returns {HTMLElement} - The cart section ID without the "shopify-section-" prefix.
*/
function mmCartSectionId() {
	return document.querySelector('.mm-cart').id.replace('shopify-section-', '');
}

/*********************************************************************************************
* Get the cart section element from the DOM.
	*
	* @returns {HTMLElement} - The cart section element.
*/
function mmCartSectionElement() {
    return document.getElementById(`${mmCartSectionIdLong()}`);
}

/*********************************************************************************************
* Get the cart product container element from the cart section.
	*
	* @returns {HTMLElement} - The cart product container element.
*/
function mmCartProductsContainerElement() {
    return mmCartSectionElement().querySelector('.mm-dc-products-container');
}

/*********************************************************************************************
* Get the cart item element for a specific product variant.
	*
	* @param {number} line_index - The line item index.
	* @returns {HTMLElement} - The cart item element.
*/
function mmCartItem(line_index) {
    return mmCartProductsContainerElement().querySelector(`[data-line-index="${line_index}"]`);
}
function mmCartItemWithId(id) {
    return mmCartProductsContainerElement().querySelector(`[data-cart-item-id="${id}"]`);
}

/*********************************************************************************************
* Get the cart item quantity element for a specific product variant.
	*
	* @param {number} line_index - The line item index.
	* @returns {HTMLElement} - The cart item quantity element.
*/
function mmCartItemQuantityEl(line_index) {
  const itemEl = mmCartItem(line_index);
	return itemEl.querySelector("[data-item-quantity]");
}

/*********************************************************************************************
* Get the quantity of a specific cart item.
	*
	* @param {number} line_index - The line item index.
	* @returns {number} - The quantity of the cart item.
*/
function mmGetCartItemQuantity(line_index ) {
    const quantityEl = mmCartItemQuantityEl(line_index);
    return Number.parseInt(quantityEl.dataset.itemQuantity);
}

/*********************************************************************************************
* Set the quantity of a specific cart item and update the DOM.
	*
	* @param {number} line_index - The line item index.
	* @param {number} newQuantity - The new quantity to set.
*/
function mmSetCartItemQuantity(line_index, newQuantity) {
	// Display quantity in front
	if (newQuantity >= 0) {
		const quantityEl = mmCartItemQuantityEl(line_index);
		quantityEl.dataset.itemQuantity = newQuantity;
		//quantityEl.innerText = newQuantity;
	}
}

/*********************************************************************************************
* Create a new cart element from the provided data.
	*
	* @param {Object} data - The data containing cart HTML.
	* @returns {HTMLElement} - The new cart element.
*/
function mmCartHTMLFromData(data) {
    const el = document.createElement('DIV');
    el.innerHTML = data.sections['mm-cart'];
    return el;
}

/*********************************************************************************************
* Extract the items container from the new cart HTML.
	*
	* @param {Object} data - The data containing cart HTML.
	* @returns {HTMLElement} - The items container element.
*/
function extractItemsFromCartHTML(data) {
    const el = mmCartHTMLFromData(data);

    return el.querySelector('.mm-dc-products-container');
}

/*********************************************************************************************
* Insert cart products from the response data into the current cart in the DOM.
	*
	* @param {Object} data - The data containing the new cart HTML.
	* @returns {Object} - The response data.
*/
function insertCartProductsFromResponse(data) {
    const itemsContainer = extractItemsFromCartHTML(data);
    mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;
    return data;
}

/*********************************************************************************************
* Extract the total price element from the new cart HTML.
	*
	* @param {Object} data - The data containing the new cart HTML.
	* @returns {HTMLElement} - The total price element.
*/
function extractTotalPriceFromCartHTML(data) {
    const cartEl = mmCartHTMLFromData(data);
    return cartEl.querySelector('[data-cart-total-price]');
}

/*********************************************************************************************
* Insert the total price from the response data into the current cart in the DOM.
	*
	* @param {Object} data - The data containing the new cart HTML.
	* @returns {Object} - The response data.
*/
function insertInsertTotalPriceFromResponse(data) {
    const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
    const currentTotalPriceEl = mmCartSectionElement().querySelector('[data-cart-total-price]');
    currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;
    return data;
}

/*********************************************************************************************
* Perform an API request to fetch or update cart data.
	*
	* @param {string} method - The HTTP method (GET, POST, etc.).
	* @param {string} path - The API endpoint path.
	* @param {Object} body - The request body data.
	* @returns {Promise<Object>} - A promise resolving to the response data.
*/
function mmAPIRequest(method, path, body) {
    document.querySelector('.mm-dc-products')?.classList?.add('mm-inactive');
    return fetch(window.Shopify.routes.root + path, {
        method: method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    })
        .then((response) => response.json())
        .then((data) => {
            // mmLog(data);
            document.querySelector('.mm-dc-products')?.classList?.remove('mm-inactive');
            updateCartCount(data.item_count != null ? data.item_count : 0);
            if (data.status && data.status > 400) {
                throw data;
            } else {
                return data;
            }
        });
}

/*********************************************************************************************
* Fetch the current cart data.
	*
	* @returns {Promise<Object>} - A promise resolving to the cart data.
*/
function mmGetCart() {
    return mmAPIRequest('GET', 'cart.js');
}

/*********************************************************************************************
	* Open the cart drawer and fetch the latest cart data.
*/
function mmOpenCart() {
    mmGetCart();
	const cartFilter = document.querySelector('.mm-drawer-cart-filter');
    const html = document.querySelector('html');
    const filter = document.querySelector('[data-filter]');

    if (!cartFilter || !html || !filter) return;

    cartFilter.classList.add('mm-dc-is-open');
    //html.classList.add('stop-scrolling');
    document.querySelector('#ShopifyChat')?.classList.add('mm-opacity-0');
    document.querySelector('#axeptio_overlay')?.classList.add('mm-opacity-0');

    // Immediately ensure the background filter is active
	showBgFilter();

    // Adjust the z-index after a short delay
    setTimeout(() => {
        filter.style.zIndex = 'var(--index)';
    }, 300);
}

/*********************************************************************************************
* Close the cart drawer and allow page scrolling.
	*
*/
function mmCloseCart() {
    hideBgFilter();
    document.querySelector('.mm-drawer-cart-filter').classList.remove('mm-dc-is-open');
    //document.querySelector('html').classList.remove('stop-scrolling');
    document.querySelector('#ShopifyChat')?.classList.remove('mm-opacity-0');
    document.querySelector('#axeptio_overlay')?.classList.remove('mm-opacity-0');
    closePopupDetails();
}

/*********************************************************************************************
* Close the popup details
	*
*/
function closePopupDetails() {
  const popupToClose = document.querySelector(".mm-item-cart-popup-container:not(.hidden)");

  if (popupToClose) {
    popupToClose.classList.add('hidden');
  }
}

/*********************************************************************************************
* Re-render the cart inner HTML from the response data and initialize Splide carousels.
	*
	* @param {Object} data - The data containing the new cart HTML.
	* @returns {Object} - The response data.
*/
function refreshCartFromData(data) {
    const newCartEl = document.createElement('DIV');
    newCartEl.innerHTML = data.sections[mmCartSectionId()];
    const innerCart = mmCartSectionElement().querySelector('.mm-drawer-cart-filter');
    innerCart.innerHTML = newCartEl.querySelector('.mm-drawer-cart-filter').innerHTML;
    mmInitSplideRea();
    mmInitSplideCross();
    mmSetupCartProductForms();

    return data;
}

/*********************************************************************************************
* Extract and organize form data into parent and children products
* @private
* @param {FormData} formData - The form data from the product form
* @returns {Object} Object containing parent and children product data
*/
function mmExtractProductsFromFormData(formData) {
	const products = {
		parent: null,
		children: []
	};

	// Organize form entries by product index (items[0], items[1], etc.)
	const itemsMap = new Map();
	
	for (const [key, value] of formData.entries()) {
		// Match items[N]... pattern
		const itemMatch = key.match(/^items\[(\d+)\](.*)/);

		if (itemMatch) {
			const index = parseInt(itemMatch[1]);
			const fieldName = itemMatch[2];

			if (!itemsMap.has(index)) {
				itemsMap.set(index, {
					id: null,
					quantity: 1,
					properties: {}
				});
			}

			const item = itemsMap.get(index);

			// Handle different field types
			if (fieldName === 'id') {
				item.id = value;
			} else if (fieldName === 'quantity') {
				item.quantity = parseInt(value) || 1;
			} else if (fieldName.startsWith('properties[')) {
				// Extract property name from properties[PropertyName]
				const propMatch = fieldName.match(/properties\[([^\]]+)\]/);
				if (propMatch && value) {
					item.properties[propMatch[1]] = value;
				}
			}
		} else if (key === 'id' || key === 'quantity' || key.startsWith('properties[')) {
			// Handle standard Shopify form inputs (without items[0] prefix)
			if (!itemsMap.has(0)) {
				itemsMap.set(0, {
					id: null,
					quantity: 1,
					properties: {}
				});
			}
			const item = itemsMap.get(0);
			if (key === 'id') {
				item.id = value;
			} else if (key === 'quantity') {
				item.quantity = parseInt(value) || 1;
			} else if (key.startsWith('properties[')) {
				const propMatch = key.match(/properties\[([^\]]+)\]/);
				if (propMatch && value) {
					item.properties[propMatch[1]] = value;
				}
			}
		}
	}

	// Convert map to array sorted by index
	const sortedItems = Array.from(itemsMap.entries())
		.sort((a, b) => a[0] - b[0])
		.map(([index, item]) => item)
		.filter(item => item.id); // Only keep items with an ID

	// First item is the parent, rest are children
	if (sortedItems.length > 0) {
		products.parent = sortedItems[0];
		products.children = sortedItems.slice(1);
	}

	return products;
}

/*********************************************************************************************
* Add parent product to cart (supports files for ordonnance uploads)
* @private
* @param {Object} parentProduct - The parent product data
* @param {FormData} originalFormData - Original form data (for file uploads)
* @returns {Promise<Object>} Promise resolving to the cart line data with key
*/
async function mmAddParentToCart(parentProduct, originalFormData) {
	// Check if original FormData contains files
	let hasFiles = false;
	if (originalFormData) {
		for (const [key, value] of originalFormData.entries()) {
			if (value instanceof File && (key.startsWith('items[0]') || key.startsWith('properties['))) {
				hasFiles = true;
				break;
			}
		}
	}

	let response;

	if (hasFiles) {
		// Use FormData to preserve file uploads
		const parentFormData = new FormData();

		// Copy parent fields from original FormData (including files)
		// Supports both items[0] prefix format and standard format (id, quantity, properties[])
		// Files from children (items[1]+) will be handled by mmAddChildToCart
		for (const [key, value] of originalFormData.entries()) {
			if (key.startsWith('items[0]')) {
				// Remove the items[0] prefix to get the correct field name
				// items[0]id -> id
				// items[0]quantity -> quantity
				// items[0]properties[Name] -> properties[Name]
				const newKey = key.replace(/^items\[0\]/, '');
				parentFormData.append(newKey, value);
			} else if (key === 'id' || key === 'quantity' || key.startsWith('properties[')) {
				// Standard Shopify form format — already correct key names
				parentFormData.append(key, value);
			}
		}
		
		response = await fetch("/cart/add.js", {
			method: "POST",
			body: parentFormData
		});
	} else {
		// Use JSON for faster processing when no files
		response = await fetch("/cart/add.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify(parentProduct)
		});
	}

	if (!response.ok) {
		const errorText = await response.text();
		throw new Error(`Failed to add parent: ${response.status} - ${errorText}`);
	}

	const data = await response.json();
	return data;
}

/*********************************************************************************************
* Add child product to cart with parent relationship
* @private
* @param {Object} childProduct - The child product data
* @param {string} parentKey - The parent cart line key
* @param {FormData} originalFormData - Original form data (for file uploads)
* @param {number} childIndex - Index of child in items array (1, 2, 3, etc.)
* @returns {Promise<Object>} Promise resolving to the cart line data
*/
async function mmAddChildToCart(childProduct, parentKey, originalFormData, childIndex) {
	// Check if this child has file uploads
	let hasFiles = false;
	if (originalFormData) {
		for (const [key, value] of originalFormData.entries()) {
			if (value instanceof File && key.startsWith(`items[${childIndex}]`)) {
				hasFiles = true;
				break;
			}
		}
	}

	let response;
	
	if (hasFiles) {
		// Use FormData to preserve file uploads
		const childFormData = new FormData();
		
		// Add child product basic fields
		childFormData.append('id', childProduct.id);
		childFormData.append('quantity', childProduct.quantity);
		childFormData.append('parent_line_key', parentKey);
		
		// Copy ALL items[childIndex] fields from original FormData (including files)
		for (const [key, value] of originalFormData.entries()) {
			if (key.startsWith(`items[${childIndex}]`)) {
				const newKey = key.replace(`items[${childIndex}]`, '');
				// Skip id and quantity as we already added them
				if (newKey !== 'id' && newKey !== 'quantity') {
					childFormData.append(newKey, value);
				}
			}
		}
		
		response = await fetch("/cart/add.js", {
			method: "POST",
			body: childFormData
		});
	} else {
		// Use JSON for faster processing when no files
		const childWithParent = {
			...childProduct,
			parent_line_key: parentKey
		};

		response = await fetch("/cart/add.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify(childWithParent)
		});
	}

	if (!response.ok) {
		const errorText = await response.text();
		console.warn(`⚠️  Failed to add child: ${response.status} - ${errorText}`);
		throw new Error(`Failed to add child: ${response.status} - ${errorText}`);
	}

	const data = await response.json();
	return data;
}

/*********************************************************************************************
* Add products to cart with nested cart lines support
* @private
* @param {Object} products - Object containing parent and children products
* @param {FormData} originalFormData - Original form data (for file uploads)
* @returns {Promise<void>}
*/
async function mmAddProductsWithNesting(products, originalFormData) {
	const { parent, children } = products;

	if (!parent || !parent.id) {
		throw new Error('No parent product to add');
	}

	// Step 1: Add parent product (with file support)
	const parentData = await mmAddParentToCart(parent, originalFormData);
	const parentKey = parentData.key;

	// Small delay to ensure parent is fully processed
	await new Promise(resolve => setTimeout(resolve, 100));

	// Step 2: Add children products with parent relationship
	if (children && children.length > 0) {
		// Add children SEQUENTIALLY (not in parallel) to avoid file upload conflicts
		const results = [];
		for (let index = 0; index < children.length; index++) {
			const child = children[index];
			const childIndex = index + 1; // items[1], items[2], items[3], etc.
			
			try {
				const result = await mmAddChildToCart(child, parentKey, originalFormData, childIndex);
				results.push(result);
				
				// Small delay between children for file upload processing
				if (index < children.length - 1) {
					await new Promise(resolve => setTimeout(resolve, 100));
				}
			} catch (error) {
				console.error('❌ Error adding child:', error);
				results.push(null);
			}
		}

		const successCount = results.filter(r => r !== null).length;
		if (successCount < children.length) {
			console.warn(`⚠️  Only ${successCount}/${children.length} child products were added successfully`);
		}
	}
}

/*********************************************************************************************
	* Sets up the cart form submission handler with nested cart lines support.
*/
function mmSetupAllProductForms() {
	const forms = document.querySelectorAll("[data-type='add-to-cart-form']");
    const loaderFilter = document.getElementById('mm-form-submit-loader-filter');
  
	if (!forms) return;

	forms.forEach(form => {
		form.addEventListener("submit", async function (event) {
            
			event.preventDefault();
            loaderFilter.classList.add('mm-visible');

			try {
				const formData = new FormData(form);
				
				// Extract and organize products
				const products = mmExtractProductsFromFormData(formData);
				
				// Add products with nesting (pass formData for file uploads)
				await mmAddProductsWithNesting(products, formData);
				
				mmOpenAndRefreshCart();
				mmCloseAllPanels();
				
			} catch (error) {
				console.error("❌ Error adding to cart:", error);
				alert("Une erreur s'est produite lors de l'ajout au panier. Veuillez réessayer.");
			} finally {
				loaderFilter.classList.remove('mm-visible');
			}
		});
	});
}
function mmSetupCartProductForms() {
	const forms = document.querySelectorAll(".mm-cart [data-type='add-to-cart-form']");
  
	if (!forms) return;

	forms.forEach(form => {
		form.addEventListener("submit", function (event) {
			event.preventDefault();
            //mmLoadThis(form.querySelector('button[type="submit"]'));

			const formData = new FormData(form);

			fetch("/cart/add.js", {
				method: "POST",
				body: formData
			})
			.then(response => response.json())
			.then(data => {
              mmOpenAndRefreshCart();
              mmCloseAllPanels();
              //mmStopLoadThis(form.querySelector('button[type="submit"]'));
			})
			.catch(error => {
          console.error("Erreur:", error);
			});
		});
	});
}

/*********************************************************************************************
* Refresh the cart and open the cart drawer
*/
function mmOpenAndRefreshCart() {
  const request = new XMLHttpRequest();
  request.addEventListener("load", handleResponse);
  request.open("GET", `/?section_id=${mmCartSectionId()}`, true);
  request.send();
}

function handleResponse() {
    const newCartEl = document.createElement("DIV");
    newCartEl.innerHTML = this.responseText;
    const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-filter");
    // regarder dans le DOM si le cross sell est ouvert
    const oldCrossSell = document.querySelector(".mm-dc-cross-sell-container");

  if (oldCrossSell.classList.contains('mm-open')) {
    newCartEl.querySelector(".mm-dc-cross-sell-container").classList.add('mm-open');
    newCartEl.querySelector(".mm-cross-sell-filter").classList.remove('hidden');
  }

  innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-filter").innerHTML;

  mmAddOrRemoveFreeProducts(newCartEl);
  mmOpenCart();
  mmSetupCartProductForms();

  // ─── NOUVEAU : SI on a qu’un seul produit gratuit mais plus d’1 dans le count, on vide ───
  const header = document.querySelector(".mm-dc-header");
  const cartCount = header ? parseInt(header.dataset.cartCount, 10) : 0;
  const productsContainer = document.querySelector(".mm-dc-products");
  if (
    productsContainer &&
    productsContainer.children.length === 1 &&
    productsContainer.children[0].classList.contains("mm-dc-free-product") &&
    cartCount > 1
  ) {
    // on vide le panier puis on ré-ouvre / rafraîchit
    fetch("/cart/clear.js", { method: "POST" })
      .then(() => {
        mmOpenAndRefreshCart();
      })
      .catch(err => console.error("Erreur clear cart:", err));
  }
}


/*********************************************************************************************
* Increase the quantity of a specific product in the cart by one.
	*
	* @param {number} line_index - The line item index.
*/
function mmIncreaseProductQuantity(line_index) {
    const itemCart = mmCartItem(line_index);
    const quantity = mmGetCartItemQuantity(line_index);
    const maxQtty = parseInt(itemCart.dataset.maxQuantity, 10);
    const newQuantity = quantity + 1;

    if (newQuantity > maxQtty) {
        return;
    }

    mmSetCartItemQuantity(line_index, newQuantity);
    mmDebouncedPushNewQuantity(line_index);
}

/*********************************************************************************************
	* Decrease the quantity of a specific product in the cart by one.
	*
	* @param {number} line_index - The line item index.
*/
function mmDecreaseProductQuantity(line_index) {
    const itemCart = mmCartItem(line_index)
    const quantity = mmGetCartItemQuantity(line_index);

    const maxQtty = parseInt(itemCart.dataset.maxQuantity, 10);
    const newQuantity = quantity - 1;

    if (newQuantity > maxQtty) {
        return;
    }

    mmSetCartItemQuantity(line_index, newQuantity);
    mmDebouncedPushNewQuantity(line_index);
}

/*********************************************************************************************
	* Decrease the quantity of multiple products.
	*
*/
function decreaseAllProductsQuantity(removalMap = {}, linkedProductTitle = '') {
  // 1) Récupère l'état complet du panier
  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {
      // Copie le map pour décrémenter par variant au fur et à mesure
      const remaining = { ...removalMap };
      const updates = {};

      cart.items.forEach(item => {
        const vid = String(item.variant_id);
        
        // Supprimer les verres _rainbow liés à la monture supprimée
        // Ces verres ont la propriété "Monture" = titre de la monture
        if (linkedProductTitle && item.properties) {
          const montureProperty = item.properties['Monture'];
          const isRainbow = item.properties['_rainbow'] === 'true';
          if (isRainbow && montureProperty === linkedProductTitle) {
            updates[item.key] = 0;
            return;
          }
        }
        
        // Si ce variant n'est pas dans le map, on passe
        if (remaining[vid] === undefined) return;

        const toRemove = remaining[vid];
        // Si on est déjà à zéro à retirer, on skip
        if (toRemove === 0) return;

        // Si null => suppression totale de chaque line item
        if (toRemove === null) {
          updates[item.key] = 0;
          return;
        }

        // Sinon on retire au plus toRemove de cette ligne
        const removeQty = Math.min(item.quantity, toRemove);
        const newQty = item.quantity - removeQty;
        updates[item.key] = newQty;

        // On décrémente ce qu'il reste à retirer pour ce variant
        remaining[vid] -= removeQty;
      });

      // 2) Un seul appel /cart/update.js avec line item keys
      // Shopify accepte les line item key pour cibler précisément une ligne 
      // même si variant_id est dupliqué :contentReference[oaicite:0]{index=0}
      return mmAPIRequest("POST", "cart/update.js", { updates });
    })
    .then(mmOpenAndRefreshCart)
    .catch(err => console.error(err));
}


/*********************************************************************************************
* Remove a specific product from the cart.
	*
	* @param {number} line_index - The line item index.
*/
function mmDestroyProductFromCart(line_index, cta = '') {
  const card = document.querySelector(`.mm-dc-product-container[data-line-index="${line_index}"]`);
  const elem = document.querySelector(`.mm-dc-product-price-container-${line_index}`);

  card.style.opacity = '0';

  // helper pour transformer "id1,id2," en [ "id1", "id2" ]
  function parseIds(str) {
    return (str || '')
      .replace(/,+$/, '')
      .split(',')
      .filter(id => id.trim());
  }

  // helper pour lire un qtty unique
  function parseQty(str) {
    const n = parseInt(str, 10);
    return isNaN(n) ? 0 : n;
  }

  // parse des listes d'IDs
  const correctionIds               = Array.from(new Set(parseIds(cta.dataset.correction)));
  const amincissementIds            = Array.from(new Set(parseIds(cta.dataset.amincissement)));
  const polarizedIds                = Array.from(new Set(parseIds(cta.dataset.polarized)));
  const verresSupIds                = Array.from(new Set(parseIds(cta.dataset.verresSup)));
  const verresSupCorrectionIds      = Array.from(new Set(parseIds(cta.dataset.verresSupCorrection)));
  const lumiereBleueIds             = Array.from(new Set(parseIds(cta.dataset.lumiereBleue)));
  const traitementIds               = Array.from(new Set(parseIds(cta.dataset.traitement)));

  // parse des quantités à retirer (une qtty unique par groupe)
  const correctionQty               = parseQty(cta.dataset.correctionQtty);
  const amincissementQty            = parseQty(cta.dataset.amincissementQtty);
  const polarizedQty                = parseQty(cta.dataset.polarizedQtty);
  const verresSupQty                = parseQty(cta.dataset.verresSupQtty);
  const verresSupCorrectionQty      = parseQty(cta.dataset.verresSupCorrectionQtty);
  const lumiereBleueQtty            = parseQty(cta.dataset.lumiereBleueQtty);
  const traitementQtty              = parseQty(cta.dataset.traitementQtty);

  // lecture optionnelle de data-main-qtty pour le produit principal
  const mainQty = cta.dataset.mainQtty
    ? parseQty(cta.dataset.mainQtty)
    : null; // null → suppression totale

  // Récupérer le titre du produit pour supprimer les verres _rainbow liés
  const productTitle = cta.dataset.productTitle || '';

  const hasOptions =
       correctionIds.length
    || amincissementIds.length
    || polarizedIds.length
    || verresSupIds.length
    || verresSupCorrectionIds.length
    || lumiereBleueIds.length
    || traitementIds.length
    || productTitle; // Considérer aussi le titre pour les verres _rainbow

  if (hasOptions) {
    const mainProductId = mmCartItem(line_index).dataset.cartItemId;

    // map { id: qtyToRemove|null }
    const removalMap = {};

    // suppression totale ou partielle du produit principal
    removalMap[mainProductId] = mainQty === null ? null : mainQty;

    // helper pour cumuler les qttés
    function addQty(id, qty) {
      if (qty <= 0) return;
      if (removalMap[id] === null) return;         // déjà full remove

      removalMap[id] = (removalMap[id] || 0) + qty;
    }

    // 3) Boucle sur chaque groupe, en ne passant qu'une fois par ID
    correctionIds.forEach(id =>          addQty(id, correctionQty));

    amincissementIds.forEach(id =>       addQty(id, amincissementQty));

    polarizedIds.forEach(id =>           addQty(id, polarizedQty));

    verresSupIds.forEach(id =>           addQty(id, verresSupQty));

    verresSupCorrectionIds.forEach(function(id) {
      addQty(id, verresSupCorrectionQty);
    })

    lumiereBleueIds.forEach(id =>        addQty(id, lumiereBleueQtty));

    traitementIds.forEach(id =>          addQty(id, traitementQtty));

    // Passer le titre du produit pour supprimer les verres _rainbow liés
    decreaseAllProductsQuantity(removalMap, productTitle);
  } else {
    // pas d'options : suppression classique
    if (elem) mmLoadThis(elem);
    mmSetCartItemQuantity(line_index, 0);
    mmDebouncedPushNewQuantity(line_index);
  }
}

/*********************************************************************************************
* Push the new quantity of a specific product to the server.
	*
	* @param {number} line_index - The line item index.
*/
function mmPushNewQuantity(line_index) {
      const quantity = mmGetCartItemQuantity(line_index);
      mmAPIRequest("POST", "cart/change.js", {
      line: line_index,
      quantity: quantity
    })
      .then(mmOpenAndRefreshCart)
      .catch((error) => {
        //alert(error.message);
        //location.reload();
      });
}

/*********************************************************************************************
* Remove a line item from the cart.
	*
	* @param {number|string} line_index - The index of the line item in the cart to be removed.
*/
function mmDestroyLineItemFromCart(line_index) {
    mmAPIRequest("POST", "cart/change.js", {
        line: parseInt(line_index),
        quantity: 0,
        sections: mmCartSectionId(),
    })
    .then(handleResponse);
}

/*********************************************************************************************
* Debounced function to push new quantity of a specific product to the server.
	*
	* @param {number} line_index - The line item index.
 */
const mmDebouncedPushNewQuantity = debounce(function (line_index, maxQtty) {
	const quantity = mmGetCartItemQuantity(line_index);

    if (quantity > maxQtty) {
        return;
    }
	mmPushNewQuantity(line_index);
}, 300);

/*********************************************************************************************
* Update the cart count bubble with the given value.
	*
	* @param {number} value - The new cart count value.
*/
function updateCartCount(value) {
    if (value > 0) {
        document.querySelector('.mm-cart-count-bubble').classList.remove('mm-none');
        document.querySelector('.mm-cart-count-bubble').innerText = `(${value})`;
    } else {
        document.querySelector('.mm-cart-count-bubble').classList.add('mm-none');
    }
}

/*********************************************************************************************
* Add or remove free products from the cart based on conditions.
	*
	* @param {Object} data - The data containing the new cart HTML.
	* @returns {Object} - The response data.
*/
function mmAddOrRemoveFreeProducts(new_html) {
    if (new_html) {

		const el = new_html;
		const freeProductEls = el.querySelector("[data-free-products]");

		let freeProductCounts = 0;

		// creates an object like { 44058675: 1, 44058001: 0 }
		// where key is free product id and value, its quantity
		const productsParams = Array.from(freeProductEls.children).reduce((param, freeProductEl) => {
			const productId = freeProductEl.dataset.variantId;

			const isFree = freeProductEl.dataset.freeProduct == "true";
			const itemEl = mmCartItemWithId(productId);

			if (isFree) {
				freeProductCounts += 1;
			}
			if (itemEl && isFree) {
				//console.log("do nothing, item is already added");
				// do nothing, item is already added
			} else if (itemEl && !isFree) {
				//console.log("item is present but should be removed");
				// item is present but should be removed
				param[productId] = 0;
			} else if (!itemEl && isFree) {
				//console.log("item is absent but should be added", productId);
				// item is absent but should be added
				param[productId] = 1;
			} else {
              //console.log('else')
            }
			//console.log(param);

			return param;
		}, {});

		// Add or remove free products only if needed
		if (Object.keys(productsParams).length > 0) {
			mmAPIRequest("POST", "cart/update.js", {updates: productsParams, sections: mmCartSectionId()}).then(refreshCartFromData);
		}
	}
}

/*********************************************************************************************
* Add a free product to the cart and optionally open the cart drawer.
	*
	* @param {number} productId - The free product ID to add.
	* @param {Object} options - Options for adding the product.
	* @param {number} [options.quantity=1] - The quantity to add.
	* @param {boolean} [options.openCart=true] - Whether to open the cart drawer after adding the product.
	* @param {HTMLElement} clickedElem - The element that was clicked to trigger this action.
*/
function mmAddFreeProductToCart(productId, { quantity = 1, openCart = true }, clickedElem) {
    // Debounce on the CTA
    clickedElem.innerText = 'AJOUTÉ !';
    clickedElem.classList.add('mm-disabled');

    // Ajouter le free product
    mmAddProductToCart(productId, { openCart: false });
}

/* Mobile Cross sell */
if (window.innerWidth < 769) {

  function mmOpenCrossSell() {
    const crossSellFilter = document.querySelector(".mm-cross-sell-filter");
    const crossSellContainer = document.querySelector(".mm-dc-cross-sell-container");

    crossSellFilter.classList.remove('hidden');
    crossSellContainer.classList.add('mm-open');
  }
  function mmCloseCrossSell() {
    const crossSellFilter = document.querySelector(".mm-cross-sell-filter");
	  const crossSellContainer = document.querySelector(".mm-dc-cross-sell-container");

		crossSellFilter.classList.add("hidden");
		crossSellContainer.classList.remove("mm-open");
  }
}

/*********************************************************************************************
* Loaded Listenner
	*
*/
window.addEventListener('DOMContentLoaded', (event) => {
    mmGetCart();
});

document.addEventListener('DOMContentLoaded', () => {
	mmInitSplideRea();
	mmInitSplideCross();
	mmSetupAllProductForms();
},
{ once: true });


/*********************************************************************************************
* Decrement the quantity of a cart item by 1, handling nested lines (corrections, etc.).
* If current quantity is 1, the item is fully removed.
* Lines with a locked quantity (data-qty-locked, e.g. lenses sold by pair) are ignored.
*
* @param {number} lineIndex - The line item index (forloop.index).
* @param {HTMLElement} ctaEl - The .mm-dc-product-actions container holding data-attributes.
*/
function mmDecrementCartItem(lineIndex, ctaEl) {
  if (ctaEl.dataset.qtyLocked === 'true') return;

  const currentQty = mmGetCartItemQuantity(lineIndex);
  if (currentQty <= 1) {
    delete ctaEl.dataset.mainQtty;
  } else {
    ctaEl.dataset.mainQtty = '1';
  }
  mmDestroyProductFromCart(lineIndex, ctaEl);
}

/*********************************************************************************************
* Increment the quantity of a cart item by 1, handling nested lines (corrections, etc.).
* Lines with a locked quantity (data-qty-locked, e.g. lenses sold by pair) are ignored.
*
* @param {number} lineIndex - The line item index (forloop.index).
* @param {HTMLElement} ctaEl - The .mm-dc-product-actions container holding data-attributes.
*/
function mmIncrementCartItem(lineIndex, ctaEl) {
  if (ctaEl.dataset.qtyLocked === 'true') return;

  function parseIds(str) {
    return (str || '').replace(/,+$/, '').split(',').filter(function(id) { return id.trim(); });
  }
  function parseQty(str) {
    var n = parseInt(str, 10);
    return isNaN(n) ? 0 : n;
  }

  var mainVariantId = String(mmCartItem(lineIndex).dataset.cartItemId);

  var correctionIds          = Array.from(new Set(parseIds(ctaEl.dataset.correction)));
  var amincissementIds       = Array.from(new Set(parseIds(ctaEl.dataset.amincissement)));
  var polarizedIds           = Array.from(new Set(parseIds(ctaEl.dataset.polarized)));
  var verresSupIds           = Array.from(new Set(parseIds(ctaEl.dataset.verresSup)));
  var verresSupCorrectionIds = Array.from(new Set(parseIds(ctaEl.dataset.verresSupCorrection)));
  var lumiereBleueIds        = Array.from(new Set(parseIds(ctaEl.dataset.lumiereBleue)));
  var traitementIds          = Array.from(new Set(parseIds(ctaEl.dataset.traitement)));

  var correctionQty          = parseQty(ctaEl.dataset.correctionQtty);
  var amincissementQty       = parseQty(ctaEl.dataset.amincissementQtty);
  var polarizedQty           = parseQty(ctaEl.dataset.polarizedQtty);
  var verresSupQty           = parseQty(ctaEl.dataset.verresSupQtty);
  var verresSupCorrectionQty = parseQty(ctaEl.dataset.verresSupCorrectionQtty);
  var lumiereBleueQty        = parseQty(ctaEl.dataset.lumiereBleueQtty);
  var traitementQty          = parseQty(ctaEl.dataset.traitementQtty);

  // Build increment map: variantId (string) -> qty to add
  var incrementMap = {};
  incrementMap[mainVariantId] = 1;

  function addIncrement(id, qty) {
    if (!id || qty <= 0) return;
    incrementMap[id] = (incrementMap[id] || 0) + qty;
  }

  correctionIds.forEach(function(id)          { addIncrement(id, correctionQty); });
  amincissementIds.forEach(function(id)       { addIncrement(id, amincissementQty); });
  polarizedIds.forEach(function(id)           { addIncrement(id, polarizedQty); });
  verresSupIds.forEach(function(id)           { addIncrement(id, verresSupQty); });
  verresSupCorrectionIds.forEach(function(id) { addIncrement(id, verresSupCorrectionQty); });
  lumiereBleueIds.forEach(function(id)        { addIncrement(id, lumiereBleueQty); });
  traitementIds.forEach(function(id)          { addIncrement(id, traitementQty); });

  fetch('/cart.js')
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      var updates = {};
      // Track which variants have been processed to handle duplicate variant lines
      var processed = {};

      cart.items.forEach(function(item) {
        var vid = String(item.variant_id);
        if (incrementMap[vid] === undefined) return;
        if (processed[vid]) return;
        processed[vid] = true;
        updates[item.key] = item.quantity + incrementMap[vid];
      });

      return mmAPIRequest('POST', 'cart/update.js', { updates: updates });
    })
    .then(mmOpenAndRefreshCart)
    .catch(function(err) { console.error(err); });
}

// Remove property from item
function mmRemoveColorProperty(lineIndex, propertyName) {

    const data = {
      line: lineIndex,
      properties: { propertyName: '' }
    };

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(res => res.json())
    .then(cart => {
    })
    .catch(error => {
      console.error('Erreur lors de la mise à jour du panier:', error);
    });
}










